import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

// Hooks
import { useFilterPills } from 'app/shared/modules/MobileSRP/ListingCards/FilterPills/useFilterPills';

// Misc / utils
import numberUtils from 'app/shared/utils/numberUtils';
import * as S from './styles';
import type { RootReduxState } from 'app/shared/flux/reducers';

const FilterPills = () => {
  // Redux
  const totalListings = useSelector((state: RootReduxState) => state.listings.totalListings);
  const numDefaultFilterListings = useSelector((state: RootReduxState) => state.listings.numDefaultFilterListings);

  const listingsExcluded = numDefaultFilterListings - totalListings;

  // Hooks
  const { initialize, handleClearAllFilters, handleFilterItemRemoval, filterLabels, filterLabelCounts, isLoading } =
    useFilterPills();

  // When component mounts, initialize and get filter counts
  useEffect(() => {
    initialize();
  }, [initialize]);

  if (isLoading || !filterLabels?.length) {
    return null;
  }

  return (
    <S.FilterTabsArticle>
      {listingsExcluded > 0 && (
        <>
          <S.ExcludedText>
            {numberUtils.prettyPrintNumber(listingsExcluded)}
            <S.SecondaryExcludedText as="span">properties are excluded</S.SecondaryExcludedText>
          </S.ExcludedText>
          <S.RemoveSomeFiltersText>Remove some filters?</S.RemoveSomeFiltersText>
        </>
      )}
      <S.FilterLabelsContainer>
        {filterLabels.map((label) => {
          if (!label) return null;
          const key = label[0];
          const filterLabel = label[1];
          if (!key || !filterLabel || typeof key !== 'string') return null;

          const count = filterLabelCounts ? (filterLabelCounts as Record<string, number>)[key] : null;

          return (
            <S.FilterPill
              key={`filter-pill-${key}-${filterLabel}`}
              filterKey={key}
              onItemClearClick={handleFilterItemRemoval}
            >
              {filterLabel}
              {count && <S.FilterPillCount>{`(${count})`}</S.FilterPillCount>}
            </S.FilterPill>
          );
        })}
      </S.FilterLabelsContainer>
      <S.ClearAllFiltersButton onClick={handleClearAllFilters}>Clear all filters</S.ClearAllFiltersButton>
    </S.FilterTabsArticle>
  );
};

export default FilterPills;
